<section class="margin-top scanning-agent-debug-mode-section" aria-labelledby="scanning-agent-debug-mode-heading">
  <div class="d-flex align-items-center">
    <div id="scanning-agent-debug-mode-heading" class="label">{{ 'scanning_agent_debug_mode' | translate }}</div>
  </div>
  <p class="mb-1" id="scanning-agent-debug-mode-description">{{ 'scanning_agent_debug_mode_description' | translate }}</p>
  <app-toggle-switch
    name="ScanningAgentDebugMode"
    data-test-id="scanning-agent-debug-mode-switch"
    [value]="value()"
    (valueChange)="onValueChange($event)"
    switchContainerClass="d-flex align-items-center mt-2"
    aria-describedby="scanning-agent-debug-mode-description"
  >
    <span class="switch-label">{{ 'enable_scanning_agent_debug_mode_switch' | translate }}</span>
  </app-toggle-switch>
</section>
